import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { useDispatch, useSelector } from "react-redux";
import useCatalogos from "../../../hooks/useCatalogos";
import { APIURL } from "../../../Constantes";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import { obtenerGaleriaPaqueteMayoritaAction, elimarImagenTipoPaqueteMayorista } from "../../../ducks/proveedorMayoristaDuck";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    width: 500,
    height: 350,
  },
  formControl: {
    width: "100%",
    margin: "15px 0"
  },
  imageItem: {
    '& img': {
      cursor: 'pointer',
      transition: 'transform 0.2s',
      '&:hover': {
        transform: 'scale(0.9)'
      }
    }
  }
}));

const ImageItem = (props) => {
  const { item, onDelete } = props;
  const [hover, setHover] = useState(false);

  return (
    <img
      loading="lazy"
      onClick={() => onDelete(item)}
      src={`${APIURL}/Package/V2/Wholesaler/Gallery/Image/${item.IdPaqueteMayoristaImagen}`}
      alt={item.NombreImagen}
      height={200}
      width={200}
      style={{
        left: 0,
        cursor: hover ? 'pointer' : 'default',
        transition: 'transform 0.2s',
        objectFit: "cover",
        transform: hover ? 'scale(1.1)' : 'scale(1)',
        position: 'relative',
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    />
  );
};

const Galeria = (props) => {
  const { clavePaquete = "D" } = props;
  const dispatch = useDispatch();
  const galeria = useSelector((state) => state.proveedorMayorista.galeria);
  const classes = useStyles();
  const catTipoImagenes = useCatalogos("TipoImagen");
  const [idTipoImagen, setIdTipoImagen] = useState(1);

  useEffect(() => {
    dispatch(obtenerGaleriaPaqueteMayoritaAction({
      clavePaquete: clavePaquete, 
      tipo: idTipoImagen
    }));
  }, [dispatch, clavePaquete, idTipoImagen]);

  const handleSelecTipoImagen = (event) => {
    setIdTipoImagen(event.target.value);
  };
  
  const onDelete = (image) =>{
    DialogMessage.fire({
      title: '',
      text: '',
      imageUrl: `${APIURL}/Package/V2/Wholesaler/Gallery/Image/${image.IdPaqueteMayoristaImagen}`,
      imageWidth: 400,
      imageHeight: 200,
      imageAlt: 'Custom image',
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) =>{
      if (result.isConfirmed) {
        dispatch(onLoadAnction({message: ""}))
        dispatch(elimarImagenTipoPaqueteMayorista({idPaqueteMayoristaImagen: image.IdPaqueteMayoristaImagen})).then(() =>{
          dispatch(offLoadAction())
          ToastMessage.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          )
          dispatch(obtenerGaleriaPaqueteMayoritaAction(clavePaquete, idTipoImagen))
        })
      }
    })
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="lTipoImagen">Tipo de imagen</InputLabel>
          <Select
            labelId="lTipoImagen"
            id="STipoImagen"
            name="tipoImagen"
            value={idTipoImagen}
            onChange={handleSelecTipoImagen}
            label="Tipo de imagen"
          >
            <MenuItem value="0" disabled>
              {"Seleccione una opción"}
            </MenuItem>
            {catTipoImagenes.map((item, index) => (
              <MenuItem key={item.IdTipoImagen} value={item.IdTipoImagen}>
                {`${item.Descripcion}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <ImageList rowHeight={170} className={classes.imageList} cols={3}>
          {galeria.length === 0 && (
            <Grid item xs={12} className={classes.noImages}>
              <Typography variant="body1" color="textSecondary">
                No hay imágenes disponibles para este tipo
              </Typography>
            </Grid>
          )}
          
          {galeria.length > 0 && galeria.map((item) => (
            <ImageListItem key={item.IdPaqueteMayoristaImagen} cols={item.cols || 1}>
              <ImageItem item={item} onDelete={onDelete} />
            </ImageListItem>
          ))}
        </ImageList>
      </Grid>
    </Grid>
  );
};

export default Galeria;
